<template>
  <!--
          作者：luoyiming
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="昵称/手机号">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称/手机号"></el-input>
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="formInline.gradeId" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.gradeId">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>

      </el-form>

    </div>
    <div class="common-level-rail">
      <el-button type="danger" plain icon="el-icon-download" size="mini" @click="handleExport"
                   v-hasPermi="['mall:orderinfo:exportUser']">导出</el-button>
      <!--<el-button size="small" type="primary" @click="finishClick" icon="el-icon-money" v-hasPermi="['mall:orderinfo:finish']">结算</el-button>-->
   </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%" v-loading="loading">
            <el-table-column type="selection" width="55" align="center" />

            <el-table-column prop="userId" label="ID" width="80"></el-table-column>
          <el-table-column prop="nickname" label="昵称"></el-table-column>
          <el-table-column label="微信头像">
            <template slot-scope="scope">
              <img :src="scope.row.avatarurl" width="30px" height="30px" />
            </template>
          </el-table-column>
          <el-table-column prop="gradeName" label="会员等级"></el-table-column>
          <el-table-column prop="balance" label="余额"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="createTime" label="注册时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="handleOrderList(scope.row)" type="text" size="small" >分销订单</el-button>
              <el-button @click="handleUserList(scope.row)" type="text" size="small">分销用户</el-button>
              <el-button @click="handleFinish(scope.row)" type="text" size="small">结算</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-size="pageSize" :page-sizes="[20, 50, 100, 200,500,1000]" layout="sizes,total, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <el-dialog :title="title"   :visible.sync="open" width="1200px" append-to-body>
      <el-form ref="form" :model="form"  label-width="200px">
        <el-table v-loading="loading" :data="orderInfoList">
          <el-table-column type="expand">
            <template slot-scope="scope">
            <el-table v-loading="loading" :data="scope.row.productList">
              <el-table-column label="商品名称" prop="productName" />
              <el-table-column label="商品规格" prop="productAttr" />
              <el-table-column label="商品单价" prop="productPrice" />
              <el-table-column label="购买数量" prop="totalNum" />
              <el-table-column label="实付金额" prop="totalPayPrice" />
              <el-table-column label="商品佣金(%)" prop="agentPro" />
              <el-table-column label="佣金(元)" prop="agent" />
            </el-table>
            </template>
          </el-table-column>


          <el-table-column label="订单编号" prop="orderNo"  width="200px"/>
          <el-table-column label="用户名" prop="nickname"  />
          <el-table-column label="状态" prop="orderStatus" >
            <template slot-scope="scope">
              <span>{{scope.row.orderStatus == '30' ? '已完成' : '未完成'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="结算状态" prop="isSettled" >
            <template slot-scope="scope">
              <span>{{scope.row.isSettled == '1' ? '已结算' : '未结算'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="orderPrice" width="80px"/>
          <el-table-column label="退款金额" prop="refundMoney" width="80px"/>
          <el-table-column label="佣金" prop="tolAgentPro" width="80px"/>
          <el-table-column label="订单时间" align="center" prop="createTime" width="180px" >
          </el-table-column>
          <el-table-column label="团长名" align="center" prop="topName" width="150px" />
          <el-table-column label="团长电话" align="center" prop="topTel" width="150px" />
        </el-table>
          <div class="pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange2" background
                             :current-page="curPage2" :page-size="pageSize2" :page-sizes="[20, 50, 100, 200,500,1000]" layout="total, prev, pager, next, jumper"
                             :total="totalDataNumber2"></el-pagination>
          </div>
      </el-form>
    </el-dialog>

    <!-- 查看团长下所有的用户-->
    <el-dialog :title="title" :visible.sync="user" width="800px" append-to-body>
      <el-form ref="form" :model="form"  label-width="200px">
        <el-table v-loading="loading" :data="userInfoList">
          <el-table-column label="用户编号" prop="userId"  />
          <el-table-column label="用户名" prop="nickname" />
          <el-table-column label="手机号" prop="mobile" />
        </el-table>
          <div class="pagination">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange3" background
                             :current-page="curPage3" :page-size="pageSize3" :page-sizes="[20, 50, 100, 200,500,1000]" layout="total, prev, pager, next, jumper"
                             :total="totalDataNumber3"></el-pagination>
          </div>
<!--        <pagination-->
<!--                v-show="userTotal>0"-->
<!--                :total="userTotal"-->
<!--                :page.sync="userParams.pageNum"-->
<!--                :limit.sync="userParams.pageSize"-->
<!--                @pagination="queryGroup(userParams)"-->
<!--        />-->
      </el-form>

    </el-dialog>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'add')"></Recharge>
    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList"
      @closeDialog="closeDialogFunc($event, 'edit')"></Grade>
    <!--会员标签-->
    <Tag v-if="open_tag" :open_tag="open_tag" :form="userModel" @closeDialog="closeDialogFunc($event, 'tag')"></Tag>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  import qs from 'qs';
  import {getCookie} from '@/utils/base.js';

  export default {
    components: {
      /*编辑组件*/

    },
    data () {
      return {
          open: false,
          user:false,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
          pageSize2: 20,
          ids:[],

          /*一共多少条数据*/
        totalDataNumber: 0,
          totalDataNumber2: 0,
          totalDataNumber3: 0,

          /*当前是第几页*/
        curPage: 1,
          curPage2: 1,
          curPage3: 1,

          /*横向表单数据模型*/
        formInline: {
          nickName: '',
          gradeId: '',
          tagId: 0,
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
          openId: '',

          /*等级*/
        gradeList: [],
          orderInfoList: [],
          form: {},

          open_tag: false,
        /*所有标签*/
        allTag: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
      };
    },
    created () {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      /*选择第几页*/
      handleCurrentChange (val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange (val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
        /*选择第几页*/
        handleCurrentChange2 (val) {
            let Params = this.formInline;
            this.curPage1=val;
            Params.openId=this.openId;
            console.log("this",Params)

            this.loading = true;
            this.handleOrderList(Params);
        },
        /*选择第几页*/
        handleCurrentChange3 (val) {
            let Params = this.formInline;
            this.curPage3=val;
            Params.openId=this.openId;
            this.loading = true;
            this.handleUserList(Params);
        },

        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.openId)
            this.single = selection.length!=1
            this.multiple = !selection.length
        },
      /*获取列表*/
      getTableList () {
        let self = this;
        let Params = self.formInline;
        Params.pageIndex = self.curPage;
        Params.pageSize = self.pageSize;
        UserApi.grouplist(Params, true)
          .then(res => {
            self.loading = false;
            self.tableData = res.data.userList.records;
            self.totalDataNumber = res.data.userList.total;
            self.gradeList = res.data.gradeList;
            self.allTag = res.data.tagList;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      cancel() {
        this.open = false;
        this.user = false;

        this.reset();
      },
      /** 查看按钮操作 */
      handleOrderList(row) {
          this.loading = true;
          this.open = true;
          this.title = "分销订单";
          this.openId=row.openId;
          console.log("ddd",row)
          let self = this;

          let Params = self.formInline;
          Params.pageIndex = self.curPage1;
          Params.pageSize = self.pageSize1;
          Params.openId=row.openId;
          UserApi.groupOrderlist(Params).then(response => {
              console.log('==============',response.data.orderList);
          this.orderInfoList = response.data.orderList.records;
              self.totalDataNumber2 = response.data.orderList.total;
              self.curPage2=response.data.orderList.pageIndex;
              self.pageSize2=response.data.orderList.pageSize
              this.open = true;
          this.loading = false;

          });
      },
        /** 分销用户 */
        handleUserList(row) {
            this.loading = true;
            this.user = true;
            this.title = "分销用户";
            this.openId=row.openId;
            console.log("ddd",row)
            let self = this;
            let Params = self.formInline;
            Params.pageIndex = self.curPage3;
            Params.pageSize = self.pageSize3;
            Params.topOpenId=row.openId;
            UserApi.groupUserlist(Params).then(response => {
                console.log('=======user=======',response.data.userList);
                this.userInfoList = response.data.userList.records;
                self.totalDataNumber3 = response.data.userList.total;
                self.curPage3=response.data.userList.pageIndex;
                self.pageSize3=response.data.userList.pageSize
                this.user = true;
                this.loading = false;
              Params.topOpenId=null;
            });
        },
      /*搜索查询*/
      onSubmit () {
        let self = this;
        self.loading = true;
        self.curPage = 1;
        self.getTableList();
      },

      /*打开添加*/
      addClick (item) {
        let self = this;
        // let params = row.orderId;
        self.$router.push({
          path: '/user/group/order',
          // query: {
          //   orderId: params
          // }
        });
      },

      /*打开编辑*/
      editClick (item) {
        this.userModel = item;
        this.open_edit = true;
      },

      tagClick (item) {
        this.userModel = item;
        this.open_tag = true;
      },

      /*关闭弹窗*/
      closeDialogFunc (e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
        if (f == 'tag') {
          this.open_tag = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
        /** 导出按钮操作 */
        handleExport() {

            let _this=this;
            if(_this.ids.length<1){
                this.$message.error("请先选择要导出的团长数据！");
                return;
            }
            this.$confirm('是否确认导出选择的团长下所有订单数据吗?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(function() {
              let Params = {};
              Params.ids = _this.ids;
              Params.token = getCookie('token');

              let baseUrl = window.location.protocol + '//' + window.location.host;
              window.location.href = baseUrl + '/api/shop/user/group/export?' + qs.stringify(Params);
                // return UserApi.exportUserOrderList({ids:_this.ids});
            }).then(response => {
              // console.log("response",response);
              // alert("")
              //   this.download(response.msg);
            }
            )
        },
      /*结算*/
      handleFinish(row) {
        let self = this;
        self
          .$confirm('是否结算该团长下的所有未结算订单, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            UserApi.finishOrder(
              {
                openId: row.openId
              },
              true
            )
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，用户结算成功！',
                    type: 'success'
                  });
                  self.getTableList();
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {
            self.loading = false;
          });
      }
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/group/index.vue